import { Button, Flex, Modal, ModalBody, ModalContent, ModalOverlay, Text } from '@chakra-ui/react';

import { radius } from 'styles/revampTokens';

interface Properties {
  isOpen: boolean;
  onClose: () => void;
  itemName: string;
  onDelete: () => void;
}

/**
 * Shared destructive-confirm shell for the V2 UI — first built for the
 * Dimensions row/table delete, reused as-is for the block card's delete so
 * the two don't drift into two different "are you sure?" modals the way the
 * dropdown menus did (see components/ActionMenuList).
 */
const DeleteModal = ({ isOpen, onClose, itemName, onDelete }: Properties) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered blockScrollOnMount={false}>
      <ModalOverlay />
      <ModalContent width='411px' maxWidth='90vw' borderRadius={radius.overlay} p='16px'>
        <ModalBody p={0}>
          <Flex direction='column' align='center' gap='20px'>
            <Text
              textAlign='center'
              fontFamily='Comfortaa'
              fontWeight='bold'
              fontSize='18px'
              color='#121826'
            >
              Delete {itemName}
            </Text>
            <Text
              textAlign='center'
              fontFamily='Roboto Regular'
              fontSize='13px'
              lineHeight='16px'
              color='#708090'
            >
              This action will permanently remove {itemName}. You won&apos;t be able to recover it.
            </Text>
            <Flex gap='16px' width='100%'>
              <Button
                flex={1}
                bg='white'
                border='1px solid #D1D6DD'
                borderRadius={radius.control}
                fontFamily='Roboto Regular'
                fontWeight='500'
                fontSize='13px'
                color='#121826'
                p='12px'
                height='auto'
                transition='transform 0.1s ease, background 0.15s ease'
                _hover={{ bg: 'gray.50' }}
                _active={{ transform: 'scale(0.97)' }}
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button
                flex={1}
                bg='#FE552F'
                borderRadius={radius.control}
                fontFamily='Roboto Bold'
                fontWeight='700'
                fontSize='13px'
                color='white'
                p='12px'
                height='auto'
                transition='transform 0.1s ease, background 0.15s ease'
                _hover={{ bg: '#E54B29' }}
                _active={{ transform: 'scale(0.97)' }}
                onClick={onDelete}
              >
                Yes, Delete
              </Button>
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default DeleteModal;
